var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/api/get-partner-access-token.ts
import { leagueFetch } from "@leagueplatform/league-fetch";
var IDENTITY_PARTNER_TOKEN_PATH = "v1/identity-partner-token";
var getPartnerAccessToken = (partnerId) => __async(void 0, null, function* () {
  var _a, _b;
  const params = new URLSearchParams({ partnerId });
  const res = yield leagueFetch(
    `${IDENTITY_PARTNER_TOKEN_PATH}?${params.toString()}`
  );
  if (!res.ok) {
    throw new Error(`Fetch partner token failed: ${yield res.text()}`);
  }
  const data = yield res.json();
  const token = (_b = (_a = data.data) == null ? void 0 : _a.attributes) == null ? void 0 : _b.accessToken;
  if (!token) {
    throw new Error("No access token found in fetch partner token response.");
  }
  return token;
});

// src/api/get-saml-response-form.ts
var getSamlResponseForm = (partnerId, url) => __async(void 0, null, function* () {
  var _a;
  const token = yield getPartnerAccessToken(partnerId);
  const ssoResponse = yield fetch(url, {
    headers: new Headers({
      Authorization: `Bearer ${token}`
    })
  });
  if (!ssoResponse.ok) {
    throw new Error(`SSO Proxy request failed: ${yield ssoResponse.text()}`);
  }
  if (!((_a = ssoResponse.headers.get("Content-Type")) == null ? void 0 : _a.includes("text/html"))) {
    throw new Error(
      `SSO Proxy response is not in expected 'text/html' format. Content-Type: ${ssoResponse.headers.get(
        "Content-Type"
      )}`
    );
  }
  const formResponse = yield ssoResponse.text();
  return formResponse;
});

// src/util/open-sso-saml-response-url.ts
var openSsoSamlResponseUrl = (partnerId, url) => __async(void 0, null, function* () {
  const formResponse = yield getSamlResponseForm(partnerId, url);
  const w = window.open("about:blank");
  if (w) {
    w.document.open();
    w.document.write(formResponse);
    w.document.close();
  }
});
export {
  IDENTITY_PARTNER_TOKEN_PATH,
  getPartnerAccessToken,
  getSamlResponseForm,
  openSsoSamlResponseUrl
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/sso-util'] = window.leagueSDKsPresent['@leagueplatform/sso-util'] || [];
    window.leagueSDKsPresent['@leagueplatform/sso-util'].push('2.22.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/sso-util'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/sso-util module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map